import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faPlayCircle,
  faCopy,
  faStar
} from "@fortawesome/free-regular-svg-icons";
library.add(faPlayCircle, faCopy, faStar);
